import { api } from '../config';

const { baseUrn, routes } = api;

// Device Categories
export const GET_DEVICE_CATEGORIES = (): string =>
  `${baseUrn.deviceMapping}${routes.deviceCategories.urn}`;

// Device Mapping Service
export const POST_DEVICE_MAPPING_REQUESTS = (): string =>
  `${baseUrn.deviceMapping}${routes.deviceMappingRequests.urn}`;

export const GET_DEVICE_MAPPING_REQUEST = (payload: { id: string }): string =>
  `${baseUrn.deviceMapping}${routes.deviceMappingRequests.urn}/${payload.id}`;

// Device Telemetry Service
export const POST_DEVICE_TELEMETRY_REQUESTS = (): string =>
  `${baseUrn.deviceTelemetry}${routes.deviceTelemetryRequests.urn}`;

export const GET_DEVICE_TELEMETRY_REQUESTS = (): string =>
  `${baseUrn.deviceTelemetry}${routes.deviceTelemetryRequests.urn}`;
